import axios from "axios";
import { refreshMagToken, clearMagSession } from "./magSession";

// Same-origin: API-Aufrufe laufen immer ueber die Domain, auf der die App
// gerade geoeffnet ist (Ingress leitet /api an das Backend weiter).
export const BACKEND =
  typeof window !== "undefined" ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Gleitender 7-Tage-Login: verlaengert das Backend die Sitzung, liefert es ein frisches
// App-JWT im Header `X-WD-Session`. Das speichern wir still, damit die Sitzung bei
// aktiver Nutzung weiterlaeuft. Bei 401 auf geschuetzten /magauth-Routen -> Abmelden.
api.interceptors.response.use(
  (response) => {
    const t = response?.headers?.["x-wd-session"];
    if (t) refreshMagToken(t);
    return response;
  },
  (error) => {
    const url = error?.config?.url || "";
    const protectedMag = url.includes("/magauth/") && !url.includes("/magauth/auth/");
    if (error?.response?.status === 401 && protectedMag && sessionStorage.getItem("mag_token")) {
      clearMagSession();
      if (window.location.pathname !== "/" && !window.location.pathname.startsWith("/login")) {
        window.location.assign("/");
      }
    }
    return Promise.reject(error);
  }
);

export function fmtError(e, fallback = "Ein Fehler ist aufgetreten.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || e?.message || fallback;
}

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "gerade eben";
  if (min < 60) return `vor ${min} Min.`;
  const h = Math.floor(min / 60);
  if (h < 24) return `vor ${h} Std.`;
  const days = Math.floor(h / 24);
  return `vor ${days} T.`;
}
